export const EVENT_MINECRAFT_HEARTBEAT = "EVENT_MINECRAFT_HEARTBEAT";
